export default {
  userVerificationImage: null,
};

